export default {
  userVerificationImage: null,
};

